module.exports = __webpack_public_path__ + "static/media/edit-custom-field.40b63dd6.svg";